import type { ComponentProps, ReactNode } from "react"
import { forwardRef } from "react"

type Props = ComponentProps<"svg">

const InboxMark = forwardRef<SVGSVGElement, Props & { mark: ReactNode }>(
	({ mark, ...props }, ref) => (
		<svg
			viewBox="0 0 18 18"
			fill="none"
			stroke="currentColor"
			strokeWidth="1.5"
			strokeLinecap="round"
			strokeLinejoin="round"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
			ref={ref}
		>
			<path d="M9.25 3.75H4.75a2 2 0 0 0-2 2v7.5a2 2 0 0 0 2 2h8.5a2 2 0 0 0 2-2v-4.5" />
			<path d="M2.75 10.25h3.1l.9 1.75h4.5l.9-1.75h3.1" />
			{mark}
		</svg>
	),
)

export const InboxCheckIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<InboxMark
		{...props}
		ref={ref}
		mark={<path d="M11.5 3.75l1.5 1.5 3-3.25" />}
	/>
))

export const InboxXmarkIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<InboxMark {...props} ref={ref} mark={<path d="M12 2l3 3M15 2l-3 3" />} />
))

export const InboxDotIcon = forwardRef<SVGSVGElement, Props>((props, ref) => (
	<InboxMark
		{...props}
		ref={ref}
		mark={
			<circle cx="13.5" cy="3.75" r="2" fill="currentColor" stroke="none" />
		}
	/>
))
